<dx-scroll-view height="100%" width="100%" class="with-footer single-card">
  <h2 class="content-block">{{message.messageTitle}}</h2>
  <div class="content-block dx-card responsive-paddings">
    <div [innerHtml]=message.messageHtml></div>
  </div>
</dx-scroll-view>
